import { gql } from '@apollo/client';

export const SIGN_IN_QUERY = gql`
  mutation MyMutation {
    signInAdmin {
      admin {
        createdat
        id
        email
        name
        suborganizationid
        tenantid
        updatedat
      }
      message
      status
    }
  }
`;
